import styled from "styled-components";
import { TransitionGroup } from "react-transition-group";

export const StyledTransitionGroup = styled(TransitionGroup)``;
